(function () {
  'use strict';

  var STORAGE_KEY = 'fa_recent_searches_v1';
  var MAX_RECENT = 5;

  function joinRoot(root, path) {
    return (root || '/').replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function readRecent() {
    try {
      var value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter(function (item) { return typeof item === 'string' && item.trim(); }).slice(0, MAX_RECENT) : [];
    } catch (error) {
      return [];
    }
  }

  function writeRecent(items) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_RECENT))); } catch (error) {}
  }

  function remember(query) {
    query = String(query || '').trim();
    if (query.length < 2) return;
    var lower = query.toLocaleLowerCase(document.documentElement.lang || undefined);
    var next = readRecent().filter(function (item) {
      return item.toLocaleLowerCase(document.documentElement.lang || undefined) !== lower;
    });
    next.unshift(query);
    writeRecent(next);
  }

  function prepareSearchSubmit(form) {
    var field = form && form.querySelector('input[name="q"]');
    if (!field) return;
    var query = String(field.value || '').replace(/\*+$/g, '').trim();
    if (!query) return;
    remember(query);
    var hidden = form.querySelector('input[data-fa-wildcard-query]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'q';
      hidden.setAttribute('data-fa-wildcard-query', '');
      form.appendChild(hidden);
    }
    hidden.value = query + '*';
    field.removeAttribute('name');
  }

  function groupPriceUnit(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.fa-product-card').forEach(function (card) {
      var priceBox = card.querySelector('.product-item__price-list, .price-list');
      if (!priceBox) return;
      var unit = priceBox.querySelector('.fa-product-card__price-unit, .fa-v9-unit-label');
      var current = priceBox.querySelector('.price--highlight, .price:not(.price--compare):not(.price--compare-at)');
      if (!unit || !current) return;
      var group = priceBox.querySelector('.fa-product-card__current-price');
      if (!group) {
        group = document.createElement('span');
        group.className = 'fa-product-card__current-price';
        priceBox.insertBefore(group, current);
      }
      if (current.parentNode !== group) group.insertBefore(current, group.firstChild);
      if (unit.parentNode !== group) group.appendChild(unit);
    });
  }

  function initSearch(overlay) {
    if (!overlay || overlay.dataset.faBound) return;
    overlay.dataset.faBound = 'true';

    var dialog = overlay.querySelector('.fa-search-v1__dialog');
    var input = overlay.querySelector('[data-fa-search-dialog-input]');
    var form = overlay.querySelector('[data-fa-search-form]');
    var clearButton = overlay.querySelector('[data-fa-search-clear]');
    var status = overlay.querySelector('[data-fa-search-status]');
    var idle = overlay.querySelector('[data-fa-search-idle]');
    var loading = overlay.querySelector('[data-fa-search-loading]');
    var results = overlay.querySelector('[data-fa-search-results]');
    var allLink = overlay.querySelector('[data-fa-search-all]');
    var recentSection = overlay.querySelector('[data-fa-recent-section]');
    var recentList = overlay.querySelector('[data-fa-recent-list]');
    var root = overlay.dataset.rootUrl || '/';
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-fa-search-input]'));
    var activeTrigger = null;
    var timer = null;
    var controller = null;
    var restoringFocus = false;
    var lastQuery = '';

    function updateClear() {
      clearButton.hidden = !input.value;
    }

    function renderRecent() {
      var items = readRecent();
      recentList.innerHTML = '';
      recentSection.hidden = !items.length;
      items.forEach(function (query) {
        var button = document.createElement('button');
        button.type = 'button';
        button.textContent = query;
        button.addEventListener('click', function () {
          input.value = query;
          updateClear();
          run(query);
          input.focus();
        });
        recentList.appendChild(button);
      });
    }

    function showIdle(message) {
      idle.hidden = false;
      loading.hidden = true;
      results.hidden = true;
      allLink.hidden = true;
      status.textContent = message || '';
    }

    function showLoading() {
      idle.hidden = true;
      loading.hidden = false;
      results.hidden = true;
      allLink.hidden = true;
      status.textContent = overlay.dataset.loadingLabel || '';
    }

    function setAllLink(query, visible) {
      allLink.href = joinRoot(root, 'search') + '?q=' + encodeURIComponent(query + '*') + '&type=product';
      allLink.hidden = !visible;
    }

    function close() {
      if (overlay.hidden) return;
      overlay.hidden = true;
      document.documentElement.classList.remove('fa-search-v1-open');
      if (controller) controller.abort();
      window.clearTimeout(timer);
      restoringFocus = true;
      var restore = activeTrigger;
      activeTrigger = null;
      if (restore && restore.isConnected) restore.focus();
      window.setTimeout(function () { restoringFocus = false; }, 0);
    }

    function open(trigger) {
      if (restoringFocus) return;
      activeTrigger = trigger || activeTrigger || document.activeElement;
      var triggerValue = trigger && typeof trigger.value === 'string' ? trigger.value : '';
      if (triggerValue && !input.value) input.value = triggerValue;
      overlay.hidden = false;
      document.documentElement.classList.add('fa-search-v1-open');
      renderRecent();
      updateClear();
      window.requestAnimationFrame(function () {
        input.focus();
        if (input.value.trim().length >= 2) run(input.value.trim());
        else showIdle(input.value.trim().length ? overlay.dataset.typeMoreLabel : '');
      });
    }

    function renderResponse(html, query) {
      results.innerHTML = html;
      var predictive = results.querySelector('[data-fa-predictive]');
      var count = predictive ? parseInt(predictive.dataset.resultCount, 10) || 0 : 0;
      var products = predictive ? parseInt(predictive.dataset.productCount, 10) || 0 : 0;
      loading.hidden = true;
      idle.hidden = true;
      results.hidden = false;
      status.textContent = count ? products + ' ' + (overlay.dataset.resultsLabel || '') + ' “' + query + '”' : '';
      setAllLink(query, count > 0);
      groupPriceUnit(results);
    }

    function fetchResults(query) {
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = joinRoot(root, 'search/suggest') +
        '?q=' + encodeURIComponent(query + '*') +
        '&section_id=fa-predictive-search' +
        '&resources[type]=product,collection,query' +
        '&resources[limit]=8' +
        '&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last';
      var options = { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } };
      if (controller) options.signal = controller.signal;
      fetch(url, options)
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search failed');
          return response.text();
        })
        .then(function (html) {
          if (query !== lastQuery) return;
          renderResponse(html, query);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (query !== lastQuery) return;
          loading.hidden = true;
          results.hidden = true;
          idle.hidden = false;
          allLink.hidden = true;
          status.textContent = overlay.dataset.errorLabel || '';
        });
    }

    function run(value) {
      var query = String(value || '').trim();
      lastQuery = query;
      window.clearTimeout(timer);
      updateClear();
      if (query.length < 2) {
        if (controller) controller.abort();
        showIdle(query.length ? overlay.dataset.typeMoreLabel : '');
        return;
      }
      showLoading();
      setAllLink(query, false);
      timer = window.setTimeout(function () { fetchResults(query); }, 170);
    }

    triggers.forEach(function (trigger) {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', 'fa-search-v1-input');
      trigger.addEventListener('focus', function () { open(trigger); });
      trigger.addEventListener('click', function () { open(trigger); });
    });

    overlay.querySelectorAll('[data-fa-search-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });
    input.addEventListener('input', function () { run(input.value); });
    clearButton.addEventListener('click', function () {
      input.value = '';
      run('');
      input.focus();
    });
    form.addEventListener('submit', function () { remember(input.value); });
    overlay.querySelector('[data-fa-recent-clear]').addEventListener('click', function () {
      writeRecent([]);
      renderRecent();
    });
    overlay.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-fa-query-chip]');
      if (chip) remember(chip.textContent);
    });
    overlay.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(dialog.querySelectorAll('a[href],button:not([disabled]):not([hidden]),input:not([disabled])')).filter(function (node) {
        return node.offsetWidth || node.offsetHeight || node.getClientRects().length;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }

  function init() {
    var overlay = document.querySelector('[data-fa-search-v1]');
    if (overlay) initSearch(overlay);
    groupPriceUnit(document);
    document.querySelectorAll('form[role="search"]').forEach(function (form) {
      if (form.dataset.faRememberBound) return;
      form.dataset.faRememberBound = 'true';
      form.addEventListener('submit', function () { prepareSearchSubmit(form); });
    });
    var page = document.querySelector('[data-fa-search-page][data-query]');
    if (page) remember(page.dataset.query);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
